import { ComponentWithPermissions } from '../../../../../../baseComponents/CreateRoutering/types'
import BaseScreenTable from '../../../../../../baseComponents/TwinTable/BaseScreenTable'
import TableBuyDeliveryNotes from '../../../../../../specificComponents/buys/TableBuyDeliveryNotes'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import ModalCreateBuyDeliveryNote from './ModalCreateBuyDeliveryNote'

interface BuyDeliveryNotesProps extends ComponentWithPermissions { }

const BuyDeliveryNotes: React.FC<BuyDeliveryNotesProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('buyDeliveryNotes', 'Albaranes'),
        newText: t('newBuyDeliveryNote', 'Nuevo albarán'),
    }

    return (
        <BaseScreenTable TableComponent={TableBuyDeliveryNotes} CreateModalComponent={ModalCreateBuyDeliveryNote} pageData={pageData} userPermissions={userPermissions} />
    )
}

export default BuyDeliveryNotes